import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SettingsComponent } from './components/settings/settings.component';
import { AppMaterialModule } from '../app-material/app-material.module';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatTabsModule } from '@angular/material/tabs';
import { CompanyInfoComponent } from './components/company-info/company-info.component';
import { CompanyEditInfoComponent } from './components/company-edit/company-edit-info/company-edit-info.component';
import { CompanyEditUsersComponent } from './components/company-edit/company-edit-users/company-edit-users.component';
import { CompanyEditCustomizeComponent } from './components/company-edit/company-edit-info/company-edit-customize/company-edit-customize.component';

import { CompanyEditComponent } from './components/company-edit/company-edit.component';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSliderModule } from '@angular/material/slider';
import { ColorSelectorComponent } from './components/company-edit/company-edit-info/company-edit-customize/color-selector/color-selector.component';
import { CreateUserComponent } from './components/company-edit/company-edit-users/create-user/create-user.component';
import { NgxMaskModule } from 'ngx-mask';
import { CreateReceiverComponent } from './components/company-edit/company-edit-users/create-receiver/create-receiver.component';
import { ClickOutsideDirective } from 'src/app/shared/directives/click-outside.directive';
import { OnlyNumbersDirective } from 'src/app/shared/directives/only-numbers.directive';
import { UiSwitchModule } from 'ngx-ui-switch';
import { InputNumberCustomizedComponent } from '../input-number-customized/input-number-customized.component';
import { CompanyEditSettingsComponent } from './components/company-edit/company-edit-settings/company-edit-settings.component';
import { FilterCompaniesPipe } from 'src/app/shared/pipes/filter-companies.pipe';
import { InputPhoneNumberWithFlagComponent } from './components/company-edit/input-phone-number-with-flag/input-phone-number-with-flag.component';
import { TooltipDeitresModule } from 'src/app/common/ui/tooltip/tooltipDeitres.module';
import { ReceiversListComponent } from './components/company-edit/company-edit-info/company-edit-customize/receivers-list/receivers-list-component';
import { UsersListComponent } from './components/company-edit/company-edit-info/company-edit-customize/users-list/users-list-component';
import { ReceiverCreateProcessDialogComponent } from './components/company-edit/company-edit-info/company-edit-customize/receiver-create-process-dialog/receiver-create-process-dialog-component';
import { SharedModule } from '../shared/shared.module';
import { ConfigurationListComponent } from './components/company-edit/company-edit-info/company-edit-customize/configuration-list-component/configuration-list-component';

@NgModule({
  declarations: [
    ClickOutsideDirective,
    OnlyNumbersDirective,
    SettingsComponent,
    CompanyInfoComponent,
    CompanyEditInfoComponent,
    CompanyEditUsersComponent,
    CompanyEditSettingsComponent,
    CompanyEditCustomizeComponent,
    CompanyEditComponent,
    ColorSelectorComponent,
    CreateUserComponent,
    ReceiversListComponent,
    ConfigurationListComponent,
    UsersListComponent,
    CreateReceiverComponent,
    InputNumberCustomizedComponent,
    FilterCompaniesPipe,
    InputPhoneNumberWithFlagComponent,
    ReceiverCreateProcessDialogComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    AppMaterialModule,
    TranslateModule,
    FlexLayoutModule,
    MatTabsModule,
    MatStepperModule,
    FormsModule,
    ReactiveFormsModule,
    MatSliderModule,
    NgxMaskModule.forRoot(),
    UiSwitchModule.forRoot({
      size: 'small',
      color: '#FFCC00',
      switchColor: 'white',
      defaultBgColor: '#F2F5F8',
      defaultBoColor: 'transparent',
    }),
    TooltipDeitresModule,
    SharedModule,
  ],
})
export class SettingsModule {}
